import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20collage%20with%20sneakers%20floating%20diagonally%20across%20a%20warm%20terracotta%20and%20ivory%20gradient%20backdrop%2C%20soft%20ethereal%20morning%20glow%20with%20diffused%20hazy%20lighting%2C%20abstract%20geometric%20shapes%20in%20muted%20sage%20green%20overlapping%20the%20composition%2C%20editorial%20high%20fashion%20art%20photography%20with%20dreamy%20atmospheric%20depth%2C%20subtle%20fabric%20texture%20overlay%20throughout%20the%20entire%20frame%2C%20no%20harsh%20edges%20or%20shadows&width=1800&height=1000&seq=hero-bg-v2&orientation=landscape"
          alt="ACBuySpreadsheet product tracking system"
          title="ACBuySpreadsheet - Product Tracking System"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-12">
        <div className="max-w-3xl">
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl text-background-50 leading-[1.1] mb-6">
            ACBuy<br />Spreadsheet<br />System
          </h1>
          <p className="text-sm md:text-base text-background-50/80 max-w-lg mb-8 leading-relaxed">
            Track, compare, and manage products instantly with the ACBuySpreadsheet system — a next-generation spreadsheet-based shopping intelligence tool.
          </p>
          <Link
            to="/what-is-acbuyspreadsheet"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500/90 hover:bg-primary-500 text-background-50 font-semibold text-sm rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Learn More
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      {/* Bottom slogan */}
      <div className="absolute bottom-0 left-0 right-0 z-10 pb-8 md:pb-12">
        <p className="font-heading text-4xl md:text-7xl lg:text-9xl text-background-50/15 text-center tracking-wider select-none">
          TRACK. COMPARE. BUY.
        </p>
      </div>
    </section>
  );
}